import React, { useEffect, useState } from "react";
import FadeIn from "react-fade-in";
import styled from "styled-components";
import { ERRORPAGE, STARTPAGE } from "Consts/pageTypes";

export const PageTransition = ({ children, transitionDuration, delay, alias, element, wide = false }) => {
	useEffect(() => {
		if (element != undefined) {
			element.style.minHeight = "0px";
			element.style.backgroundImage = alias == ERRORPAGE && "unset";
		}
	}, []);

	const fadeIn = (
		<FadeIn delay={delay} transitionDuration={transitionDuration}>
				{children}
		</FadeIn>
	)

	return alias != STARTPAGE ? (
		wide 
		? <TransitionWideWrapper>{fadeIn}</TransitionWideWrapper>
		: <>{fadeIn}</>
	) : (
		children
	);
};

const TransitionWideWrapper = styled.div`
	width: 100%;
`;
